  <template>
  <div class="right">
    <div class="mainTop">
      <div class="underHeader">
        <img src="../../assets/img/info.png" alt />
        当前位置：
      </div>
      <el-breadcrumb
        separator-class="el-icon-arrow-right"
        style="width:50%;height: 54px;display: inline-block;line-height: 54px;"
      >
        <el-breadcrumb-item :to="{ path: '/' }">平台首页</el-breadcrumb-item>
        <el-breadcrumb-item>裁判文书</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!-- 切换 -->
    <div class="rightTab">
      <div class="tab" :class="{active:nowIndex==0}" @click="titleTab(0)">可视化概览</div>
      <div class="tab" :class="{active:nowIndex==1}" @click="titleTab(1)">数据列表</div>
    </div>
    <!-- 可视化 -->
    <juEchart v-show="nowIndex===0" :initEchart="collapse"></juEchart>
    <!-- 数据列表 -->
    <div class="dataList" v-show="nowIndex===1">
      <!-- 查询 -->
      <div class="rightTop">
        <div class="title">
          <img src="@/assets/img/14.png" alt />
          <span>筛选条件</span>
        </div>
        <div class="con">
          <div class="conLeft1">
            <div class="selectBox">
              <span>标题：</span>
              <el-input placeholder="请输入标题" v-model="params.baseInfo_casename" clearable></el-input>
            </div>
            <div class="selectBox two">
              <span>案号：</span>
              <el-input placeholder="请输入案号" v-model="params.baseInfo_casenumber" clearable></el-input>
            </div>
            <div class="selectBox three">
              <span>法院：</span>
              <el-input placeholder="请输入法院名称" v-model="params.baseInfo_courtname" clearable></el-input>
            </div>
          </div>
          <div class="conLeft1">
            <div class="selectBox">
              <span>案由：</span>
              <el-cascader
                ref="casereason"
                collapse-tags
                v-model="baseInfo_casereason"
                :options="casereasonData"
                :show-all-levels="false"
                :props="casereason_props"
                @change="casereasonChange"
              ></el-cascader>
            </div>
            <div class="selectBox">
              <span>文书类型：</span>
              <el-select v-model="params.baseInfo_docType" placeholder="请选择">
                <el-option v-for="(item,i) in docTypeData" :key="i" :label="item" :value="item"></el-option>
              </el-select>
            </div>
            <div class="selectBox">
              <span>律所：</span>
              <el-input placeholder="请输入律所" v-model="params.lawfirm" clearable></el-input>
            </div>
          </div>
          <div class="conLeft1">
            <div class="selectBox">
              <span>律师：</span>
              <el-input placeholder="请输入律师名称" v-model="params.lawyer" clearable></el-input>
            </div>
            <div class="selectBox">
              <span>裁判日期：</span>
              <el-date-picker
                v-model="times"
                type="daterange"
                range-separator="-"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                @change="changeTimes"
              ></el-date-picker>
            </div>
            <div class="selectBox">
              <div class="button" @click="searchFun">查询</div>
            </div>
          </div>
        </div>
      </div>
      <!--下载 -->
      <div class="rightCenter">
        <div class="centerTit"></div>
        <div class="centerCon">
          <div class="no">
            <span></span>
          </div>
          <div class="cueWords" v-show="hint">最多下载1000条</div>
          <div class="excel" @click="downloadTable()" @mouseenter="enter()" @mouseleave="leave()">
            <img src="@/assets/img/Excel.png" alt />
            下载数据到Excel
          </div>
        </div>
      </div>
      <!-- 表格 -->
      <div class="rightBottom">
        <div class="tabulationBottom">
          <el-table
            :data="majorList"
            style="width: 100% background:#052B4F;"
            border
            size="mini"
            :fit="true"
            :cell-style="cellStyle1"
            @row-click="getDetails1"
          >
            <af-table-column label="序号" type="index" show-overflow-tooltip width="50"></af-table-column>
            <af-table-column
              v-for="(item,index) in headerData"
              :prop="index"
              :label="item"
              :key="index"
              v-if="item!='当事人'"
            ></af-table-column>
            <af-table-column label="当事人" prop="baseInfo_caselitigant">
              <template slot-scope="scope">
                <div>
                  <span
                    style="margin-left:5px;"
                    v-for="(v,i) in scope.row.baseInfo_caselitigant.split('|')"
                    :key="i"
                    :class="v.split('_')[1]!=''&&v.split('_')[1]!=null?'scope_p':''"
                    @click="toEnterprisesDetail(scope,v)"
                  >{{v.split('_')[0]}}</span>
                </div>
              </template>
            </af-table-column>
          </el-table>
        </div>
      </div>
      <!-- 分页 -->
      <div class="rightPaging" style="display:flex;align-item:center;">
        <div
          style="    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
      color: #BAC7D5;
      height:32px;
       line-height: 32px;"
        >共 {{totlalCount}} 条</div>
        <el-pagination
          prev-text="上一页"
          next-text="下一页"
          background
          @current-change="handleCurrentChange"
          :current-page="params.currPage"
          :page-size="params.pageSize"
          layout=" prev, pager, next, jumper"
          :total="1000"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import api from "@/../static/common/api/api.js";
window.api = api;
import magic from "@/../static/common/magic.js";
import axios from "axios";
import juEchart from "@/components/juEchart.vue";

export default {
  props: {},
  components: {
    juEchart
  },
  props: ["collapse"],
  data() {
    let _self = this;
    return {
      nowIndex: 0,
      initEchart: false,
      radio: 3, //单选
      typeOnes: "",
      typeTwos: "",
      times: "",
      productNames: "",
      department: "",
      totlalCount: 0, //总条数
      docTypeData: [], //文书类型
      casereasonData: [], //案由数据
      casereasonData2: [], //案由二级数据
      baseInfo_casereason: [], //案由选择
      params: {
        pageSize: 10,
        currPage: 1
      },
      times: "",
      majorList: [],
      headerData: [],
      // 下载提示
      hint: false,
      // pickerOptions: {
      //   //日期选择范围
      //   onPick: ({ maxDate, minDate }) => {
      //     this.selectDate = minDate.getTime();
      //     if (maxDate) {
      //       this.selectDate = "";
      //     }
      //   },
      //   disabledDate: time => {
      //     if (this.selectDate !== "") {
      //       const one = 30 * 24 * 3600 * 1000;
      //       const minTime = this.selectDate - one;
      //       const maxTime = this.selectDate + one;
      //       return time.getTime() < minTime || time.getTime() > maxTime;
      //     }
      //   }
      // },
      casereason_props: {
        //案由props配置
        // lazy: true,
        // multiple: true,
        checkStrictly:true,
        children: "childrenList",
        value: "casereason_id",
        label: "casereason"
        // lazyLoad(node, resolve) {
        //   const level = node.level;
        //   const id = node.value;
        //   api.getNextCasereason(id).then(res => {
        //     let _casereason = res.data;
        //     let node = _self.changeBool(_self, _casereason, "leaf");
        //     for (let i = 0; i < _casereason.length; i++) {
        //       _self.casereasonData2.push(_casereason[i]);
        //     }
        //     resolve(_casereason);
        //   });
        // }
      }
    };
  },
  computed: {},
  methods: {
    toEnterprisesDetail(scoped, names) {
      var baseInfo_caselitigant = scoped.row.baseInfo_caselitigant;
      baseInfo_caselitigant.split("|").forEach((v, i) => {
        var name = v.split("_")[0];
        var id = v.split("_")[1];
        if (names.split("_")[0] == name) {
          var params = {
            entId: id
          };
          if (id != "null") {
            api.checkExistBussiness(params).then(res => {
              if (res.data) {
                let routeData = this.$router.resolve({
                  path: "/enterprisesDetail",
                  query: { entId: id }
                });
                window.open(routeData.href, "_blank");
              }
            });
          } else {
            this.$message.error("暂无数据!");
          }
        }
      });
    },
    // 首次展示
    firstShow() {
     let nowIndex1 = JSON.parse(sessionStorage.getItem("nowIndex"))?JSON.parse(sessionStorage.getItem("nowIndex")):0;
      this.nowIndex = nowIndex1;
    },
    // 切换
    titleTab(val) {
      this.nowIndex = val;
    },
    //将leaf里的字符串类型转成bool类型
    changeBool(_this, arr, val) {
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].childrenList.length) {
          _this.changeBool(arr[i].childrenList, val);
        } else {
          if (arr[i].hasOwnProperty(val)) {
            arr[i][val] = arr[i][val] == "false" ? "" : true;
          }
        }
      }
      return arr;
    },
    //案由事件
    casereasonChange() {
      this.params.baseInfo_casereason = this.$refs["casereason"]
        .getCheckedNodes()[0]
        .pathLabels.pop();
    },
    //时间选择
    changeTimes() {
      this.params.baseInfo_judgeDate_start = this.getTime(
        new Date(this.times[0])
      );
      this.params.baseInfo_judgeDate_end = this.getTime(
        new Date(this.times[1])
      );
    },
    //时间处理
    getTime(dt) {
      var year = dt.getFullYear(); //年
      var month = dt.getMonth() + 1; //月
      var date = dt.getDate(); //日
      month = month < 10 ? "0" + month : month;
      date = date < 10 ? "0" + date : date;
      var str = year + "-" + month + "-" + date;
      return str;
    },
    //筛选条件获取
    getQueryData() {
      let _this = this;
      api.getQueryData().then(res => {
        this.docTypeData = res.data.docType;
        // this.casereasonData = _this.changeBool(
        //   _this,
        //   res.data.casereason,
        //   "leaf"
        // );
        this.casereasonData = res.data.casereason;
      });
    },

    searchFun() {
      let _this = this;
      magic.loginOrRights(2626).then(res => {
        if (!res) {
          _this.$message.error("请您登录！");
          return;
        }
        if (res && res.rights == 0) {
          _this.$message.error("您没有权限！");
          return;
        }
        _this.getWenshuSearchData();
        // 埋点
        try {
          //LogCollection.contents["key"]="value";
          //0：浏览（已在浏览器关闭、刷新、页面跳转时自动执行，此处可提前使之执行。）
          //2：收藏 3：下载 4：分享 5：购买 6：登录 7：注册 9：搜索 10：复制 11：点赞 12：评论
          LogCollection.send(9);
        } catch (e) {}
      });
    },
    // 分页
    handleCurrentChange(val) {
      this.params.currPage = val;
      this.getWenshuSearchData();
    },
    // 表格数据
    getWenshuSearchData() {
      api.getWenshuSearchData(this.params).then(res => {
        this.totlalCount = res.data.total;
        this.majorList = res.data.data;
        this.headerData = res.data.colums;
      });
    },
    // 公司高亮
    cellStyle1({ row, column, rowIndex, columnIndex }) {
      if (column.label == "案件名称") {
        return `color:#3583ED;font-weight:bold;cursor: pointer;`;
      } else {
        return "";
      }
    },
    // 去搜索页
    getDetails1(row, column) {
      if (column.label == "案件名称") {
        let routeData = this.$router.resolve({
          path: "/detail",
          query: { ...row }
        });
        window.open(routeData.href, "_blank");
        // this.$router.push({ path: "", query: { ...row } });
      }
    },
    // 下载
    enter() {
      this.hint = true;
    },
    leave() {
      this.hint = false;
    },
    downloadTable() {
      axios({
        method: "post",
        url: window.normalUrl + "/wenshu/downWenshuData", // 请求地址
        data: this.params,
        responseType: "arraybuffer",
        observe: "response"
      }).then(res => {
        const fileName = "裁判文书.xlsx";
        let blob = new Blob([res.data], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });
        if ("download" in document.createElement("a")) {
          // 非IE下载
          const elink = document.createElement("a");
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href); // 释放URL 对象
          document.body.removeChild(elink);
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, fileName);
        }
      });
      // 埋点
      try {
        //LogCollection.contents["key"]="value";
        //0：浏览（已在浏览器关闭、刷新、页面跳转时自动执行，此处可提前使之执行。）
        //2：收藏
        //3：下载
        //4：分享
        //5：购买
        //6：登录
        //7：注册
        //9：搜索
        //10：复制
        //11：点赞
        //12：评论
        LogCollection.send(3);
      } catch (e) {}
    },
    download(data) {
      if (!data) {
        return;
      }
      let url = window.URL.createObjectURL(new Blob([data]));
      let link = document.createElement("a");
      link.style.display = "none";
      link.href = url;
      link.setAttribute("download", "excel.xlsx");
      document.body.appendChild(link);
      link.click();
    }
  },
  mounted() {
    this.firstShow(); //首次展示
    this.getWenshuSearchData();
    this.getQueryData();
  }
};
</script>
<style scoped lang="less">
.el-cascader {
  width: 332px;
}
/deep/.el-range-editor /deep/ .el-range-input {
  background: #023261;
  color: #dfecf7;
}
/deep/.el-date-editor /deep/.el-range-separator {
  color: #dfecf7;
}
/deep/ .el-range-input {
  background: #023261;
}
.scope_p {
  margin-left: 5px;
  color: #3583ed;
  font-weight: bold;
  cursor: pointer;
}
@import "../../assets/less/style.less";
@import "../../assets/less/right.less";
@import "../../assets/less/moreThanThree.less";
</style>


// WEBPACK FOOTER //
// src/view/judgement/default.vue